// writeClipboard writes text to the system clipboard using the modern
// async Clipboard API, falling back to a hidden <textarea> + document
// .execCommand for browsers that refuse the primary path (older Safari,
// insecure origins). Throws when both attempts fail so callers can
// surface a toast.
export async function writeClipboard(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return
    } catch {
      // fall through to legacy path
    }
  }
  if (typeof document === 'undefined') {
    throw new Error('clipboard unavailable')
  }
  const ta = document.createElement('textarea')
  ta.value = text
  ta.setAttribute('readonly', '')
  ta.style.position = 'fixed'
  ta.style.top = '-1000px'
  ta.style.left = '-1000px'
  document.body.appendChild(ta)
  ta.select()
  const ok = document.execCommand('copy')
  document.body.removeChild(ta)
  if (!ok) {
    throw new Error('clipboard copy failed')
  }
}
